<template>
    <a-modal
        :class="'modal epic-default'"
        :title="$t('covers.view.headers.related_claims')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <template #footer>
            <a-button data-cy="back-button" type="primary" key="back" @click="handleModalCancel">
                {{ $t('covers.view.buttons.close') }}
            </a-button>
        </template>
        <div class="form-container overflow-x-auto overflow-visible">
            <claims-table :section_type="section_type" :cover_id="cover_id" />
        </div>
    </a-modal>
</template>

<script>
import ClaimsTable from '@/components/tables/Claims.vue';

export default {
    components: {
        ClaimsTable,
    },
    data() {
        return {
            modal_visible: false,
            section_type: 'cover',
        };
    },
    props: {
        cover_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        handleModalCancel() {
            this.modal_visible = false;
        },
    },
};
</script>
